/**
 * The smallest and largest of some values, in one pass. Values that are not
 * finite numbers are skipped; `null` when none is left.
 *
 * NOT `Math.min(...values)`. Spreading passes every value as its own argument,
 * and past about 120,000 of them the engine throws "Maximum call stack size
 * exceeded". That is a day of one symbol recorded twice a second, well inside
 * the replay's million-row budget, and it took down the timeline, the Sidecar
 * card and the facts handed to the AI on exactly the long recordings they are
 * meant for.
 */
export function numberExtent(values: Iterable<unknown>): { low: number; high: number } | null {
  let low = Infinity;
  let high = -Infinity;
  for (const v of values) {
    if (typeof v !== 'number' || !Number.isFinite(v)) continue;
    if (v < low) low = v;
    if (v > high) high = v;
  }
  return low > high ? null : { low, high };
}
